import React from "react"
import { useAuthService } from "services/auth/auth-service-hooks"
import { AuthenticationGuardProps } from "types/auth"



export const AuthenticationGuardService: React.FC<AuthenticationGuardProps> = ({
    component,
}) => {
    const { AuthenticationGuard } = useAuthService()
    

    return <AuthenticationGuard component={component}/>
}

